module.exports = __webpack_public_path__ + "static/media/27.7748c482.mp3";